import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import Dashboard from '../containers/dashboard'
import { UserContext } from '../contexts/user.context'
import CustomerCompaniesManagement from '../containers/customer-companies-management'

const CustomerCompanies = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { userSession } = useContext(UserContext)
  const [displayElements, setDisplayElements] = useState<boolean>(false)

  useEffect(() => {
    if (!userSession) {
      return
    }

    if (userSession?.role !== 'admin' && userSession?.role !== 'super-admin') {
      navigate('/404')
    } else {
      setDisplayElements(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, userSession])

  return <Dashboard>{displayElements ? <CustomerCompaniesManagement /> : <></>}</Dashboard>
}

export default CustomerCompanies
